import PropTypes from "prop-types";
import React from "react";

import FormButton from "../../components/form/FormButton";
import { PropTypeShapes } from "../../types";
import HelpIcon from "../interface/HelpIcon";
import Icon from "../interface/Icon";

const ModalGroup = props => (
  <div
    className={`${props.className ? `${props.className} ` : ``}modalGroup  ${props.shrinkable ? "shrinkable" : ""}  ${
      props.expandable ? "expandable" : ""
    }`}
  >
    {props.label ? (
      <div className="modalGroupHeading">
        {props.icon ? <Icon className={props.icon} icon={props.icon} color={props.iconColor} /> : null}
        {props.label}
        {props.helpTooltip ? <HelpIcon tooltip={props.helpTooltip} /> : null}
        {props.showButton ? <FormButton onClick={props.buttonOnClick} label={props.buttonLabel} /> : null}
      </div>
    ) : null}
    {props.children}
  </div>
);

ModalGroup.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  expandable: PropTypes.bool,
  shrinkable: PropTypes.bool,
  children: PropTypeShapes.elementOrArray,
  showButton: PropTypes.bool,
  buttonOnClick: PropTypes.func,
  buttonLabel: PropTypes.string,
  helpTooltip: PropTypes.string
};

export default ModalGroup;
